export const IMPORT_STATUS_STYLES: Record<string, { pill: string; dot: string }> = {
  PENDING: { pill: 'bg-stone-100 text-stone-600', dot: 'bg-stone-400' },
  VALIDATED: { pill: 'bg-blue-100 text-blue-700', dot: 'bg-blue-500' },
  REVIEWING: { pill: 'bg-yellow-100 text-yellow-700', dot: 'bg-yellow-500' },
  COMMITTED: { pill: 'bg-green-100 text-green-700', dot: 'bg-green-500' },
  ROLLED_BACK: { pill: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  FAILED: { pill: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
}

export const IMPORT_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  VALIDATED: 'Validated',
  REVIEWING: 'Reviewing',
  COMMITTED: 'Committed',
  ROLLED_BACK: 'Rolled Back',
  FAILED: 'Failed',
}

export function isImportJobDeletable(status: string): boolean {
  return status === 'PENDING' || status === 'VALIDATED'
}

const SHORT_IMPORT_ID_LENGTH = 6

export function shortImportJobId(id: string): string {
  return id.slice(-SHORT_IMPORT_ID_LENGTH)
}
